// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bge_a bhc_bi"};